import { Card, Group, Text, Title, ThemeIcon, Container } from '@mantine/core';
import classes from './Requirements.module.css';
import { IconHistory, IconUser, IconDashboard, IconTool } from '@tabler/icons-react';

export const data = [
  {
    title: 'Tu auto no debe tener más de 15 años de antigüedad',
    icon: IconHistory,
  },
  {
    title:
      'Ser persona física o moral, el registro del auto y la documentación deben estar a nombre del solicitante.',
    icon: IconUser,
  },
  {
    title:
      'Contar con la factura original de tu auto, tarjeta de circulación, identificación oficial vigente y comprobante de domicilio.',
    icon: IconDashboard,
  },
  {
    title: 'Tener buen estado de carrocería, mecánica e interiores.',
    icon: IconTool,
  },
];

interface RequirementsProps {
  icon: React.FC<any>;
  title: React.ReactNode;
}

export function Requirement({ icon: Icon, title }: RequirementsProps) {
  return (
    <Group className={classes.item} wrap="nowrap" gap="xl">
      <ThemeIcon variant="light" size={45} radius={40}>
        <Icon size={30} stroke={1.5} />
      </ThemeIcon>
      <Text size="sm" lh={1.6} className={classes.decriptionCard}>
        {title}
      </Text>
    </Group>
  );
}

export function Requirements() {
  const items = data.map((item, index) => (
    <Requirement icon={item.icon} title={item.title} key={index} />
  ));

  return (
    <Container component={'section'} size="lg" py="xl" className={classes.wrapper} id="requisitos">
      <Card radius="md" p="xl" shadow="md" className={classes.card}>
        <Title className={classes.title} mt={5} mb={30}>
          Requisitos para obtener tu préstamo
        </Title>
        {items}
      </Card>
    </Container>
  );
}
